import { defineStore } from "pinia";

export const headerStore = defineStore('headerstore',{
    id:'headerstore',
    state:()=>({
        headerData:{
            search:''
        }
    }),
    actions:{
        searchData(){
            return this.search
        }

    },
    persist:{
        key: 'electosh-header-data',
        storage: sessionStorage
    }
})